module.exports = __webpack_public_path__ + "static/media/APP_RisingStar_152x174_3.d2fe9756.png";